import { MapPin, ClipboardCheck, HardHat } from "lucide-react";

const steps = [
  { icon: MapPin, step: "1", title: "Check Your ZIP Code", desc: "Enter your zip to see if you qualify for our special offer." },
  { icon: ClipboardCheck, step: "2", title: "Free Roof Inspection", desc: "A certified inspector evaluates your roof — 100% free, no obligation." },
  { icon: HardHat, step: "3", title: "Expert Installation", desc: "Our GAF-certified crew installs your new roof with a lifetime warranty." },
];

export const AdsThreeSteps = () => (
  <section className="py-16 bg-background">
    <div className="container mx-auto px-4 max-w-4xl">
      <h2 className="text-2xl md:text-3xl font-extrabold text-foreground text-center mb-10">
        3 Simple <span className="text-primary">Steps</span>
      </h2>
      <div className="grid md:grid-cols-3 gap-8">
        {steps.map(({ icon: Icon, step, title, desc }) => (
          <div key={step} className="text-center">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4 relative">
              <Icon className="w-7 h-7 text-primary" />
              <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center">
                {step}
              </span>
            </div>
            <h3 className="font-bold text-foreground mb-2">{title}</h3>
            <p className="text-sm text-muted-foreground">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
